<template>
  <!-- user transaction detail card start -->
  <div @showTxnStatusModal="showModal" class="user-trans-details text-left">
    <!-- TODO: Remove hidden attribute when user details are needed -->
    <div class="user-details">
      <h5 class="capitalize">{{ activeTxn.customerName.toLowerCase() }}</h5>
      <p>{{ activeTxn.email.toLowerCase() | mask }}</p>
      <p>{{ activeTxn.phone | mask }}</p>
      <span
        v-if="activeTxn.customerName"
        class="name-initials"
      >{{activeTxn.customerName[0].toUpperCase()}}</span>
    </div>
    <div class="trans-details">
      <h2>
        <i class="ic-rupee">`</i>
        {{ activeTxn.txnAmount | formatCurrency}}
        <a
          href="javascript:void(0);"
          v-if="breakupVisible"
          @click.stop="breakupVisible = !breakupVisible"
          class="toggleTransBreakup"
        >Hide Charges</a>
        <a
          href="javascript:void(0);"
          v-else
          @click.stop="breakupVisible = !breakupVisible"
          class="toggleTransBreakup"
        >Show Charges</a>
      </h2>
      <div class="transaction-breakup" v-if="breakupVisible">
        <ul class="clearfix">
          <li>
            Transaction amount
            <span>
              <i class="ic-rupee">`</i>
              {{activeTxn.txnAmount | formatCurrency}}
            </span>
          </li>

          <!-- <li v-if="parseInt(activeTxn.marketplaceFee)">
            Marketplace Fees
            <span>
              <i class="ic-rupee">`</i>
              {{activeTxn.marketplaceFee | formatCurrency}}
            </span>
          </li>-->
          <li v-if="parseInt(activeTxn.convenienceFee)">
            Convenience Fee
            <span>
              <i class="ic-rupee">`</i>
              {{activeTxn.convenienceFee | formatCurrency}}
            </span>
          </li>
          <!-- <li v-if="parseInt(activeTxn.serviceTaxPercentage)">
            Service Tax
            <span>
              <i class="ic-rupee">`</i>
              {{activeTxn.serviceTaxPercentage / 100 * activeTxn.txnAmount | formatCurrency}}
            </span>
          </li>-->
          <li
            v-if="parseInt(activeTxn.lateFeePercentage) && parseInt(activeTxn.lateFee)"
            class="late-charges"
          >
            Late Fees
            <!--charges @{{activeTxn.lateFeePercentage}}% interest-->
            <span>
              <i class="ic-rupee">`</i>
              {{activeTxn.lateFee | formatCurrency}}
            </span>
          </li>
          <li class="clearfix"></li>
        </ul>
      </div>
    </div>
    <!-- <div v-if="activeTxn.dueDate" class="settlement-date">
      <p>Settled on</p>
      <h2>{{activeTxn.dueDate | formatDate}}</h2>
    </div>-->
    <div>
      <TxnStatusUpdateDD
        :getStatusUpdateConfirmation="getStatusUpdateConfirmation.bind(this)"
        :toggleConfirmationBox="toggleConfirmationBox.bind(this)"
        :calledIn="'txnDetail'"
        :resetTxn="resetTxn.bind(this)"
        :getCurrentTxnStatus="getCurrentTxnStatus.bind(this)"
        :setCurrentTxnStatus="setCurrentTxnStatus.bind(this)"
        :setTxn="setTxn.bind(this)"
        :getTxnUpdateForm="getTxnUpdateForm.bind(this)"
        :setTxnUpdateForm="setTxnUpdateForm.bind(this)"
        :txnStatusEnum="txnStatusEnum"
        :txn="activeTxn"
        :showCancel="showCancel"
      ></TxnStatusUpdateDD>
      <button
        type="button"
        class="btn btn-sm btn-danger"
        @click.stop="resetTxn()"
        name="cancel"
        v-if="!getStatusUpdateConfirmation().status?showCancel:showCancel"
      >Cancel</button>
    </div>
  </div>
  <!-- user transaction detail card end -->
</template>

<script>
import TxnStatusUpdateDD from "./TxnStatusUpdateDD";
export default {
  name: "TransactionDetail",
  props: [
    "activeTxn",
    "txnStatusEnum",
    "updatePartialTxn",
    "setTxn",
    "getTxnUpdateForm",
    "setTxnUpdateForm",
    "getCurrentTxnStatus",
    "setCurrentTxnStatus",
    "resetTxn",
    "toggleConfirmationBox",
    "getStatusUpdateConfirmation",
    "showCancel"
  ],
  data() {
    return {
      breakupVisible: false
    };
  },
  mounted() {},
  components: { TxnStatusUpdateDD },
  methods: {
    showModal() {},
    updateTransaction(txn, status) {
      var query = {
        txnIds: [txn.id],
        status: status
      };
      this.$store
        .dispatch("updateTransaction", { sessionId: this.sessionId, query })
        .then(() => {
          txn.status = status;
        })
        .catch(err => {
          this.error = err;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.capitalize {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/TransactionDetail.vue